/// <reference path='../../interfaces/interfaces.d.ts' />

import Moment = moment.Moment;
import * as _ from 'lodash';

'use strict';

interface ITimePickerScope extends ng.IScope {
    activeElem: number;
    step: number;
    selectTime:  (time: Date) => void;
    timeRange: Moment[];
    model: string;
    time: Moment;
}


class SchemaTimePickerDirective {

    public restrict;
    public require;
    public scope;
    public template;
    public replace;

    constructor() {
        this.restrict = 'E';
        this.scope = {
            step: '@',
            model: '='
        };
        this.replace = true;
        this.template = `
            <div class="btn-group timepicker">
                <a class="btn btn-raised dropdown-toggle" data-toggle="dropdown" aria-expanded="false"
                data-ng-class="{ 'disabled': disabled }">
                    {{ time | moment: "HH:mm" }} <span class="caret"></span><div class="ripple-container"></div>
                </a>
                <ul class="dropdown-menu">
                    <li data-ng-repeat="time in timeRange track by $index"
                        data-ng-click="selectTime(time)"
                        data-ng-class="{'active': activeElem == $index}">
                        <a href="">{{time | moment: "HH:mm"}}</a>
                    </li>
                </ul>
            </div>`;
    }

    public controller = ($scope: ITimePickerScope) => {
        let MINUTES_START: number = 0; // range start from MINUTES_START
        const MINUTES_END: number = 1440;

        let step: number = $scope.step || 15; // custom or default min step

        var dereg: Function = $scope.$watch('model', () => {
            if ($scope.model) {
                $scope.time = moment($scope.model, 'HH:mm:ss');
                $scope.activeElem = this.setActiveElem($scope.time, MINUTES_START, step);
            }
        });

        $scope.timeRange = this.calcRange($scope.time, step, MINUTES_START, MINUTES_END);

        $scope.selectTime = (time: any) => {
            $scope.time = time;
            $scope.model = time.format('HH:mm:ss');
            this.setActiveElem($scope.time, MINUTES_START, step);
        };

        $scope.$on('$destroy', () => {
            dereg();
        });
    };

    private calcRange(model: Moment, step: number, MINUTES_START: number, MINUTES_END: number): Moment[] {
        let timeRange: any[] = [];
        let startDate: Moment = (moment.isMoment(model)) ? angular.copy(model) : moment();

        _.range(MINUTES_START, MINUTES_END, step).forEach((i: number) => {
            timeRange.push(moment(startDate).startOf('day').add(i, 'm'));
        });

        return timeRange;
    }

    private setActiveElem(model: Moment, start: number, step: number): number {
        return Math.floor((model.diff(moment(model).startOf('day'), 'minutes') - start) / step);
    }



    public static DirectiveFn(): SchemaTimePickerDirective {
        return new SchemaTimePickerDirective();
    }

}

angular.module('beneple.global')
    .directive('schematimepicker', SchemaTimePickerDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/directives/schematimepicker.directive.ts